export const getLocalStorageValue = (key, parse = false) => {
	if (key) {
		try {
			const item = window?.localStorage.getItem(key);
			return item ? (parse ? JSON.parse(item) : item) : null;
		} catch (error) {
			console.log(error);
		}
	}
	return null;
};

export const removeLocalStorageValue = (key) => {
	try {
		window.localStorage.removeItem(key);
	} catch (error) {
		console.error(error);
	}
};
